export default __webpack_public_path__ + "static/media/teaching-students-online-internet-learning-computer-programming_335657-3119.781a887a.jpg";